import { makeAutoObservable } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export interface IDomainFactor {
	id?: id;
	domain?: string;
	campaign_id?: id;
	daily_max_loss_factor?: number;
}

/**
 * The props to send to server
 */
export interface IDomainFactorCreateForm {
	domain?: string;
	campaign_id?: id;
	daily_max_loss_factor?: number;
}

export interface IDomainFactorEditForm extends IDomainFactorCreateForm {
	id?: id;
}

export class DomainFactorModel implements IDomainFactor {
	id?: id;
	domain?: string;
	campaign_id?: id;
	daily_max_loss_factor?: number;

	constructor(domainFactor?: IDomainFactor) {
		this.id = domainFactor?.id;
		this.domain = domainFactor?.domain ?? '';
		this.campaign_id = domainFactor?.campaign_id;
		this.daily_max_loss_factor = domainFactor?.daily_max_loss_factor;

		makeAutoObservable(this);
	}

	public getFormData(): IDomainFactor {
		const data: IDomainFactor = {
			domain: this.domain,
			daily_max_loss_factor: this.daily_max_loss_factor,
		};
		if (this.id != null) {
			data.id = this.id;
		}
		if (this.campaign_id != null) {
			data.campaign_id = this.campaign_id;
		}
		return data;
	}

	public getId(): id | undefined {
		return this.id;
	}

	public getDomain(): string | undefined {
		return this.domain;
	}

	public setDomain(domain: string): void {
		this.domain = domain;
	}

	public getCampaignId(): id | undefined {
		return this.campaign_id;
	}

	public setCampaignId(campaign_id: id): void {
		this.campaign_id = campaign_id;
	}

	public getDailyMaxLossFactor(): number | undefined {
		return this.daily_max_loss_factor;
	}

	public setDailyMaxLossFactor(daily_max_loss_factor: number | undefined): void {
		this.daily_max_loss_factor = daily_max_loss_factor;
	}
}
